export default [
    {
        path: '/signIn/index',
        meta:{
            title:'签到'
        },
        // component: (resolve) => require([Date.parse(new Date()) > Date.parse(new Date('2021/2/11 00:00:00'))&&Date.parse(new Date()) < Date.parse(new Date('2021/2/27 00:00:00')) ?'@/pages/holidaySignIn/index':'@/pages/signIn/index'], resolve)
        component: (resolve) => require(['@/pages/signIn/index_v2'], resolve)
    },
]